import React from "react";
import { FeatureArticleImage as FeatureArticleImageData } from "web/react/components/feature-article/types";
import { ImageContainer } from "web/react/emo/image-container";

interface FeatureArticleImageProps {
    image: FeatureArticleImageData;
}

export function FeatureArticleImage({
    image,
}: FeatureArticleImageProps): React.ReactElement | null {
    if (!image.image_url) {
        return null;
    }

    return (
        <ImageContainer
            imageSrc={image.image_url}
            imageCredit={image.caption}
            textStyle="caption-s"
            alt={image.caption ?? ""}
        />
    );
}
